'use client';

import { useRouter, useParams } from 'next/navigation';
import { ArticleTemplate } from './ArticleTemplate';
import { resources } from '../data/resources';

export function ArticleDetail({ slug: propSlug }: { slug?: string }) {
  const params = useParams();
  const router = useRouter();

  // Use prop slug if available, otherwise fall back to params (client-side nav)
  // Note: params.slug might be an array if catch-all, but here it's [slug] so string or string[]
  const rawSlug = propSlug || (params?.slug as string);

  // Debugging logs
  console.log('Current article param:', rawSlug);

  const decodedSlug = rawSlug ? decodeURIComponent(rawSlug) : '';
  console.log('Decoded articleName:', decodedSlug);

  const article = resources.find((r) => r.slug.toLowerCase() === decodedSlug.toLowerCase());

  console.log('Found article:', article?.title);

  if (!article) {
    if (typeof window !== 'undefined') {
      console.warn(`Article not found for slug: ${decodedSlug}. Redirecting to /resources`);
      router.replace('/resources/');
    }
    return null;
  }

  return (
    <ArticleTemplate
      title={article.title}
      category={article.category}
      introduction={article.introduction}
      heroImage={article.image}
      sections={article.sections}
      author={article.author}
      publishDate={article.publishDate}
      readingEstimation={article.readingEstimation}
      color={article.color}
      takeaways={article.takeaways}
      description={article.description}
      sources={article.sources}
    />
  );
}
